import { render, staticRenderFns } from "./ReportsDoughnutChart.vue?vue&type=template&id=999185dc&"
import script from "./ReportsDoughnutChart.vue?vue&type=script&lang=js&"
export * from "./ReportsDoughnutChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports